import { ApiRequestError } from './ApiClientService';

export const ACTIVE_SPACE_LIMIT_ERROR_CODE = 'ACTIVE_SPACE_LIMIT_REACHED';

export const isActiveSpaceLimitError = (error: unknown) => {
  if (!(error instanceof ApiRequestError)) {
    return false;
  }

  const data = error.data;

  return (
    typeof data === 'object' &&
    data !== null &&
    (data as { code?: string }).code === ACTIVE_SPACE_LIMIT_ERROR_CODE
  );
};
